import { render, staticRenderFns } from "./VgtPagination.vue?vue&type=template&id=7a9c3210&"
import script from "./VgtPagination.vue?vue&type=script&lang=js&"
export * from "./VgtPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports